import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AccessGate({ children, requireCapability }) {
  const { user, loading } = useAuth();
  const [access, setAccess] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    async function loadAccess() {
      try {
        const { data } = await api.get("/payments/access");
        setAccess(data);
      } catch (e) {
        setAccess(null);
      } finally {
        setChecking(false);
      }
    }
    loadAccess();
  }, []);

  if (loading || checking) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!access?.capabilities?.[requireCapability]) {
    return <Navigate to="/pricing" replace />;
  }

  return children;
}
